import * as Sentry from "@sentry/browser";

const environmentNames: Record<string, string> = {
  DEV: 'development',
  STG: 'staging',
  PRD: 'production',
}

const configuredEnvironment = (window as any).env.NAME

Sentry.init({
  dsn: "https://cf71343a284a9f0d61c76908f57c9eb6@o300425.ingest.sentry.io/4506678452813824",

  // Alternatively, use `process.env.npm_package_version` for a dynamic release version
  // if your build tool supports it.
  release: `synkedup-frontend@${(window as any).env.VERSION}`,
  environment: environmentNames[configuredEnvironment] ?? configuredEnvironment,
  integrations: [],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https: \/\/yourserver\.io\/api/],

  // Capture Replay for x% of all sessions,
  // plus for x% of sessions with an error
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 0.0,
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications.',
    'Object captured as exception with keys: isDefaultPrevented, isTrigger',
    'Object captured as exception with keys: isTrigger, jQuery'
  ],
  denyUrls: [
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
  ]
});

export const captureException = (error: Error) => {
  Sentry.captureException(error)
}

export const captureMessage = (message: string) => {
  Sentry.captureMessage(message)
}

export type CaptureContext = {
  tags?: Record<string, string>
  extra?: Record<string, unknown>
}

export const captureWarning = (message: string, context: CaptureContext = {}) => {
  Sentry.captureMessage(message, { level: 'warning', tags: context.tags, extra: context.extra })
}
